module.exports = __webpack_public_path__ + "static/media/picture-(117).5e8f5270.JPG";